import { useQuery } from '@tanstack/react-query';
import { GeoChecklistResponse } from '../../../models/geo-checklist/GeoChecklistResponse';
import { getGeoChecklist } from '../../../services/geo-checklist/GeoChecklistService';
import { GET_GEO_CHECKLIST } from '../../query/geo-checklist/keys';

export const useGetGeoChecklist = (projectId: number | null) => {
  const queryEnabled = !!projectId;

  const { data, isLoading, refetch } = useQuery<GeoChecklistResponse>({
    queryKey: [GET_GEO_CHECKLIST, projectId],
    queryFn: () => getGeoChecklist(projectId!),
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 30,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    enabled: queryEnabled,
  });

  return {
    data,
    isLoading: queryEnabled ? isLoading : false,
    refetch,
  };
};
